<template>
  <div class="book-info">
    <div class="head">
      <h1>Books</h1>
      <div class="row">
        <h2>{{ currentCourse.title }}</h2>
        <app-btn styling="outline" @click="$router.push('/dashboard/market/catalog')">
          {{$ml.get(`BACK TO CATALOG`)}}
        </app-btn>
      </div>
    </div>
    <div class="info-part row">
      <img :src="currentCourse.image" :alt="currentCourse.title">
      <div class="column">
        <h1>{{ currentCourse.title }}</h1>
        <div class="by">by <a href="#">Smart Fertilizer</a></div>
        <div class="description">
          {{ currentCourse.description }}
        </div>
        <app-btn
            @click="clickedBuy"
            v-if="!currentCourse.buyed"
        >
          Buy for {{currentCourse.regular_price}} £
        </app-btn>
        <app-btn
            @click="clickedRead"
            v-else
        >
          Watch
        </app-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CourseInfo",
  data() {
    return {

    }
  },
  methods: {
    clickedRead() {
      this.$router.push(`/dashboard/market/${this.currentCourse.type}/${this.currentCourse.id}`);
    },
    clickedBuy() {
      this.$store.commit('market/buyProduct', this.currentCourse.id);
    }
  },
  computed: {
    currentCourse () {
      return this.$store.getters['market/getProductById'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss">
.book-info {
  padding-left: 20px;
  .row {
    display: flex;
  }
  .column {
    display: flex;
    flex-direction: column;
  }
  .head {
    .row {
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
    }
  }
  .info-part {
    background-color: #fff;
    padding: 20px 10px;
    img {
      max-width: 200px;
      margin-right: 20px;
    }
    .description {
      margin-bottom: 0px;
    }
    .btn {
      margin-top: auto;
      margin-bottom: 20px;
    }
    .by {
      margin-bottom: 20px;
    }
    .column {
      align-items: flex-start;
    }
  }
}
</style>